import React, { Component } from 'react';
import firebase from "firebase/app";
import 'firebase/firestore';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import SalesMeetingFormSimpleComponent from './createMeeting/SalesMeetingFormSimple';
import * as DbUtils from "../../common/DbSvc";
import * as Utils from "../../common/utilSvc";
import { isNullOrUndefined } from "util";
import './UserMeetings.css';


class UserMeetingsComponent extends React.Component {

    constructor(props){
    
        //Probs include meetings, selectMeeting, selectedMeeting, userId
        super(props);

        this.state = {
            shajs:null,
            isMeetingBeingCreated: false
        }

        var shajs = require('sha.js');
        this.state.shajs = shajs;

        this.convertMeetingMapToList = this.convertMeetingMapToList.bind(this);
        this.createMeeting = this.createMeeting.bind(this);
        this.renderSingleMeetingListItem = this.renderSingleMeetingListItem.bind(this);
        this.selectMeeting = this.selectMeeting.bind(this);
    }

    createMeeting(company, attendees){
        
        //Temporary fix for date.
        let ts = Date.now();
        ts += 2*7*24*60*60*1000;

        let meeting = {
            company: company,
            attendees: attendees,
            date: ts
        }

        if(!isNullOrUndefined(company) && company.trim().length>0){
            let key = this.state.shajs('sha256').update(this.props.userId + String(ts) + company).digest('hex');
            meeting['id'] = key;
            DbUtils.createMeeting(this.props.userId, meeting);
            this.setState({
                isMeetingBeingCreated: false
            });
        }
        
    }

    convertMeetingMapToList(meetingMap){
        var meetingTempList = [];
        for (var meetingId in meetingMap) {
            // check if the property/key is defined in the object itself, not in parent
            if (meetingId in meetingMap) {           
                meetingTempList.push(meetingMap[meetingId]);
            }
        }
        meetingTempList.sort(function(a, b){if(a.date>b.date){return 1} return -1;});
        return meetingTempList;
    }

    selectMeeting(meeting){
        //Select meeting here
        this.props.selectMeeting(meeting)
    }

    renderSingleMeetingListItem(meeting, scope){
        //console.log(blockprobe);
        let attendees = Utils.getMeetingAttendeesString(meeting.attendees);
        return (
                <ListItem button 
                    selected={scope.props.selectedMeeting == meeting.id}
                    onClick={() => { scope.selectMeeting(meeting)}}
                    style={{width:'100%'}}
                    >
                    <ListItemText primary={meeting.company} secondary={attendees}/>
                </ListItem>
        );
    }

    render(){

        let scope = this;
        let meetingTempList = []; 
        meetingTempList = this.convertMeetingMapToList(this.props.meetings);

        const meetingListRender = meetingTempList.map((meeting) => 
                    (scope.renderSingleMeetingListItem(meeting, scope)));

        return (
            <div style={{margin:'1em'}}>
                <div style={{display:'flex', marginBottom:'1em'}}>
                    {!this.state.isMeetingBeingCreated?
                        <div>
                            <Button
                            color="primary"
                            variant="contained"
                            onClick={() => {this.setState({isMeetingBeingCreated: !this.state.isMeetingBeingCreated})}}>
                                Create
                            </Button>
                        </div>
                    :
                        <div>
                            <Button
                            color="primary"
                            variant="contained"
                            onClick={() => {this.setState({isMeetingBeingCreated: !this.state.isMeetingBeingCreated})}}>
                                Close
                            </Button>
                        </div>
                    }
                </div>
                <div>
                    {this.state.isMeetingBeingCreated?
                        <div 
                        style={{
                            border:'0.5px solid grey'
                        }}>
                            <SalesMeetingFormSimpleComponent 
                                company=""
                                attendees={[]}
                                createMeeting = {this.createMeeting}
                            />
                        </div>
                        :
                        null
                    }
                </div>
                <div>
                    <List>
                        {meetingListRender}
                    </List>
                </div>
            </div>
        )
    }
}
export default UserMeetingsComponent;